import { YieldFetcher } from '../../types'

const rlp = 'Resolv RLP::RLP'
const wstusr = 'Resolv wstUSR::WSTUSR'

export const rlpFetcher: YieldFetcher = {
  label: 'RLP',
  fetch: async () => {
    return { [rlp]: 0 }
  },
}

export const wstusrFetcher: YieldFetcher = {
  label: 'WSTUSR',
  fetch: async () => {
    return { [wstusr]: 0 }
  },
}
